import React, { useEffect, useState, useContext } from 'react';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import { 
    Box, 
    Button, 
    Typography, 
    Chip, 
    Grid,
    Accordion,
    AccordionActions,
    AccordionDetails,
    AccordionSummary,
    Tooltip,
    Modal,
    Divider,
    Card,
    CardHeader,
    CardActions,
    CardContent,
    Slider,
    Switch,
    Select,
    MenuItem,
    FormHelperText
} from '@mui/material';
import { fetchToken, fetchRole } from '../auth/Token';
import { api } from '../api';
import Menu from '@mui/material/Menu';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import AuthContext from "../auth/AuthProvider";
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import FormGroup from '@mui/material/FormGroup';
import Checkbox from '@mui/material/Checkbox';
import { useFormik, validateYupSchema } from 'formik';
import * as Yup from 'yup';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import AssignmentIcon from '@mui/icons-material/Assignment';
import SummarizeIcon from '@mui/icons-material/Summarize';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Autocomplete from '@mui/material/Autocomplete';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';


const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    marginBottom:'150px',
    overflowY: 'auto', 
    maxHeight:'550px', 
    '&::-webkit-scrollbar': {
        width: '5px',
    },
    '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
    },
    '&::-webkit-scrollbar-thumb': {
        background: '#888',
        borderRadius: '10px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
        background: '#555',
    } 
}));

const ItemCard = styled(Paper)(({ theme }) => ({
    backgroundColor: '#52b788',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    margin: '10px',
    display: 'flex',
    flexWrap:'wrap' 
}));

const ItemCardI = styled(Paper)(({ theme }) => ({
    backgroundColor: '#b7e4c7',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    margin: '10px' 
}));

const ItemCardSS = styled(Paper)(({ theme }) => ({
    backgroundColor: '#52b788',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    margin: '5px' 
}));

const ItemCardSI = styled(Paper)(({ theme }) => ({
    backgroundColor: '#b7e4c7',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    margin: '5px' 
}));

function formatDateToYearMonthDay(date) {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    let suffix = 'th';
  
    if (day === 1 || day === 21 || day === 31) {
      suffix = 'st';
    } else if (day === 2 || day === 22) {
      suffix = 'nd';
    } else if (day === 3 || day === 23) {
      suffix = 'rd';
    }
  
    return `${day}${suffix} ${month} ${year}`;
  }
  
  const isToday = (someDate) => {
    const today = new Date();
    return someDate.getDate() === today.getDate() &&
           someDate.getMonth() === today.getMonth() &&
           someDate.getFullYear() === today.getFullYear();
  };
  
  const renderTitle = (name, date) => {
    const formattedDate = formatDateToYearMonthDay(date);
    return (
      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
        <b>{name}: {formattedDate}</b>
      </Typography>
    );
  };

  const renderTitleDate = (date) => {
    const formattedDate = formatDateToYearMonthDay(date);
    return (
        <b>{formattedDate}</b>
    );
  };


  const PrettoSlider = styled(Slider)({
    color: '#52af77',
    height: 8,
    '& .MuiSlider-track': {
      border: 'none',
    },
    '& .MuiSlider-thumb': {
      height: 24,
      width: 24,
      backgroundColor: '#fff',
      border: '2px solid currentColor',
      '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
        boxShadow: 'inherit',
      },
      '&::before': {
        display: 'none',
      },
    },
    '& .MuiSlider-valueLabel': {
      lineHeight: 1.2,
      fontSize: 12,
      background: 'unset',
      padding: 0,
      width: 32,
      height: 32,
      borderRadius: '50% 50% 50% 0',
      backgroundColor: '#52af77',
      transformOrigin: 'bottom left',
      transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
      '&::before': { display: 'none' },
      '&.MuiSlider-valueLabelOpen': {
        transform: 'translate(50%, -100%) rotate(-45deg) scale(1)',
      },
      '& > *': {
        transform: 'rotate(45deg)',
      },
    },
  });



export default function EquipDetails(props) {
    const [details, setDetails] = useState([])
    const [ope, setOpe] = useState(false);
    const [message, setMessage] = useState("");
    const [alert, setAlert] = useState()
    const {  permissions } = useContext(AuthContext);
    const [start_date, setStart_date] = useState('')
    const [end_date, setEnd_date] = useState('')
    const member_acc_id = props.ID;
    const [deep_details, setDeep_details] = useState();
    const [deeper_details, setDeeper_details] = useState();
    const [current_services, setCurrent_services] = useState([]);
    const [current_inputs, setCurrent_inputs] = useState([]);
    const [open, setOpen] = useState(false);
    const [modal_open, setModal_open] = useState(false);
    const [modal_type, setModal_type] = useState(false);
    const [crops, setCrops] = useState([]);
    const [service_subscribed, setService_subscribed] = useState([]);
    const [input_subscribed, setInput_subscribed] = useState([]);
    const [hold_crop, setHold_crop] = useState('');
    const [hold_equipment_id, setHold_equipment_id] = useState(null);
    const [hold_acres, setHold_acres] = useState(null);
    const [private_interest, setPrivate_interest] = useState(null);
    const [int_type, setInt_type] = useState('');
    const [months, setMonths] = useState(null);
    const [slider_value, setSlider_value] = useState(1);
    const [subscribed_s, setSubscribed_s] = useState([]);
    const [subscribed_i, setSubscribed_i] = useState([]);
    const [openn, setOpenn] = React.useState(false);
    const [bags_clock, setBags_clock] = useState(null);
    const [bags_unit, setBags_unit] = useState(null);
    const [per, setPer] = useState(true);
    const [warehouses, setWarehouses] = useState([])
    const [grade_price, setGrade_price] = useState([]);
    const [available_units, setAvailable_units] = useState([]);
    const [charges, setCharges] = useState([
        {
            index_id: 0,
            charge: null,
            amount_per: null
        }
    ]);
    const [charges_done, setCharges_done] = useState();
    const [charges_ware, setCharges_ware] = useState([]);
    const [confirm_request, setConfirm_request] = useState([]);
    const [second_modal, setSecond_modal] = useState();
    const [cash_hold, set_cash_hold] = useState(null);
    const [savings_id, setSavings_id] = useState(null);
    const [not_more, setnot_more] = useState(null);
    const [hold, setHold] = useState('');

    const handleCloses = () => {
      setOpenn(false);
    };
    const handleOpen = () => {
      setOpenn(true);
    };

    const Request_SetInterest = (equipment_id) => {
      setModal_open(true);
      setHold_equipment_id(equipment_id);
    }

    const closeErr = () => {
      props.setOpen_acc(null);
    }

    const closeModal = () => {
      setOpen(false)
      setModal_open(false)
      setHold_equipment_id(null)
      set_cash_hold(null)
      setnot_more(null)
      setSavings_id(null)
    }

    const Repayments = (equip_trs_id) => {
      setOpen(true);
      setHold(equip_trs_id);
    }

    const ConfirmPayment = () => {
      handleOpen()
      const datta = new FormData()
      datta.append('equip_trs_id', hold)
      datta.append('savings_id', savings_id)
      datta.append('cash', cash_hold)

      api.post('/account/member/equipment/subscribe/payoff', datta,{
        headers: {
          Authorization: 'Bearer '+ fetchToken()
        }
      }).then(function(response){
          setMessage(response.data)
          setOpe(true)
          fetch_details();
          closeModal();
          fetch_my_details();
      }).catch(function(error){
        console.log(error)
      }).finally(function(){
        handleCloses()
      })
    }

    const Subscribe = () => {
      const data = new FormData()
      data.append('member_equip_acc_id', props.ID)
      data.append('private_interest', private_interest?private_interest:0)
      data.append('interest_type', int_type)
      data.append('months', months)
      data.append('equipment_id', hold_equipment_id)

      api.post('/account/member/equipment/subscribe', data,{
        headers: {
          Authorization: 'Bearer '+ fetchToken()
        }
      }).then(function(response){
          setMessage(response.data)
          setOpe(true)
          fetch_details();
          closeModal();
          fetch_my_details();
      }).catch(function(error){
        console.log(error)
      })

    }
    

 
  

    const currencyFormat = new Intl.NumberFormat('en-GH', {
        style: 'currency',
        currency: 'GHS',
    });


    const fetch_details = () => {
        api.get(`/account/member/equipment/get/all/${props.society_id}`,{
          headers: {
            Authorization: 'Bearer '+ fetchToken()
          }
        }).then(function(response){
            setDetails(response.data.data);
        }).catch(function(error){
          console.log(error)
        })
    }

    const fetch_my_details = () => {
      api.get(`/account/member/equipment/get/all/loans/${props.ID}`,{
        headers: {
          Authorization: 'Bearer '+ fetchToken()
        }
      }).then(function(response){
        setDeep_details(response.data?.data);
      }).catch(function(error){
        console.log(error)
      })
  }

    useEffect(()=> {
      fetch_details();
      fetch_my_details();
    },[])


    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 500,
        maxHeight: '80vh', 
        overflowY: 'auto', 
        '&::-webkit-scrollbar': {
            width: '7px',
        },
        '&::-webkit-scrollbar-track': {
            background: '#f1f1f1',
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#888',
            borderRadius: '10px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
            background: '#555',
        },
        bgcolor: 'background.paper',
        border: '1px solid #e7ecef',
        borderRadius: '7px',
        boxShadow: 24,
        p: 4,
      };

      const style_transfer = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 500,
        maxHeight: '80vh', 
        overflowY: 'auto', 
        '&::-webkit-scrollbar': {
            width: '7px',
        },
        '&::-webkit-scrollbar-track': {
            background: '#f1f1f1',
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#888',
            borderRadius: '10px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
            background: '#555',
        },
        bgcolor: 'background.paper',
        border: '1px solid #e7ecef',
        borderRadius: '7px',
        boxShadow: 24,
        p: 4,
      };


    const handleClo = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        setOpe(false);
      };
  
      const actio = (
        <React.Fragment>
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={handleClo}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </React.Fragment>
      );



    const printRef = React.useRef();
  const printRef_ret = React.useRef();
  // const [print, setPrint] = useState()

  const handlePrint = async () => {
    const element = printRef.current;
    const canvas = await html2canvas(element);
    const data = canvas.toDataURL('image/png');
  
    const pdf = new jsPDF();
    const imgProperties = pdf.getImageProperties(data);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;
  
    
    const marginLeft = 25;
    const marginTop = 25;
    const marginRight = 25;
    const marginBottom = 25; 
  
    pdf.addImage(
      data,
      'PNG',
      marginLeft,
      marginTop,
      pdfWidth - marginLeft - marginRight,
      pdfHeight - marginTop - marginBottom
    );
  
    pdf.save('CommodityTransfer.pdf');
  };
   
    
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
       <Item>
       <Grid container spacing={2}>
                    <Grid item xs={12} md={12}>
                        <Typography textAlign='center' variant='h4' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>{props.name}</b> 
                        </Typography>
                    </Grid>

                    <Grid item xs={12} md={12} sx={{ display:'flex' }}>
                        <div>
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Equipment Loans</b> 
                          </Typography>
                        </div>
                        <div style={{ marginLeft:'auto' }}>
                            <Chip
                                color="success"
                                variant="outlined"
                                label={`Current Balance ${currencyFormat.format(props.current_balance)}`}
                                sx={{
                                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                    minWidth: 0,
                                }} 
                                size='small'
                            />
                        </div>
                        <div style={{ marginLeft:'auto' }}>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b></b>
                            </Typography>
                        </div>
                    </Grid>

                    <Grid item xs={12} md={12}>
                        <div style={{ display:'flex', flexWrap:'wrap' }}>
                            {
                                details && details.map((one) => (
                                    <ItemCardI>
                                        <Grid container spacing={1}>
                                            <Grid item xs={12} md={12}>
                                                <Typography variant='h5' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                    <b>{`${one.crop} farms equipments`}</b>
                                                </Typography>
                                            </Grid>

                                            {
                                                one?.data?.map((two) => (
                                                  <ItemCard>
                                                    <Grid item xs={12} md={12}>
                                                        <div>
                                                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                <b>{two.equipment}</b>
                                                            </Typography>
                                                        </div>
                                                        <div style={{ marginLeft:'auto' }}>
                                                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                <b>Price: {currencyFormat.format(two.equipment_price_per_acre)}</b>
                                                              </Typography>
                                                        </div>
                                                        <div style={{ marginLeft:'auto' }}>
                                                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                <b>Interest/anum: {two.interest_percentage_rate_anum}%</b>
                                                              </Typography>
                                                        </div>
                                                        <div style={{ marginLeft:'auto' }}>
                                                          <Button
                                                            variant='contained'
                                                            onClick={()=>Request_SetInterest(two.id)}
                                                            size='small'
                                                            sx={{   m:1, 
                                                                borderRadius:4,
                                                                backgroundColor:'#eb5e28',
                                                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                                                minWidth: 0,
                                                                '&:hover': {
                                                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                                                backgroundColor:'#bc6c25',
                                                                color:'#000'
                                                                },
                                                            }}
                                                          >
                                                            Request
                                                          </Button>
                                                        </div>
                                                    </Grid>
                                                  </ItemCard>
                                                    
                                                ))
                                            }
                                        </Grid>
                                    </ItemCardI>
                                ))
                            }
                        </div>
                        
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <Box 
                          display='flex'
                          marginTop='5px'
                          sx={{ overflowX: 'auto', maxWidth:'550px', '&::-webkit-scrollbar': {
                                  width: '7px',
                              },
                              '&::-webkit-scrollbar-track': {
                                  background: '#f1f1f1',
                              },
                              '&::-webkit-scrollbar-thumb': {
                                  background: '#888',
                                  borderRadius: '10px',
                              },
                              '&::-webkit-scrollbar-thumb:hover': {
                                  background: '#555',
                              }}}>
                        
                          {
                            deep_details?
                            deep_details.map((item)=>(
                              <Tooltip title={(
                                <Box>
                                      <Typography textAlign='left' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Click to make repayment</b> 
                                      </Typography>
                                    <Typography textAlign='left' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        {item.personal_interest? (<b>Private Interest: {item.interest_type === 'flat_rate'?`${item.personal_interest} %`: currencyFormat.format(item.personal_interest)}</b>) : <b> Interest rate/month: {`${item.normal_int} %`}</b>}
                                    </Typography>
                                    {
                                      item.personal_interest?
                                      <Typography textAlign='left' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Interest type: {item.interest_type}</b> 
                                      </Typography>
                                      :
                                      null
                                    }
                                    <Typography textAlign='left' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Price: {currencyFormat.format(item.price)}</b> 
                                    </Typography>
                                    <Typography textAlign='left' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Period: {item.months} month(s)</b> 
                                    </Typography>
                                    <Typography textAlign='left' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Cost: {currencyFormat.format(item.cost)}</b> 
                                    </Typography>
                                </Box>
                              )}>
                                <Chip onClick={() => Repayments(item.trs_id)} key={item.trs_id} label={`${item.equipment} || ${currencyFormat.format(item.cost_left)}`} sx={{ m:1, borderRadius:2 }} />
                              </Tooltip>
                            ))
                            :<Typography textAlign='center' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='subtitle'>Equipments that you possesses will appear here</Typography>
                          }
                        </Box>
                    </Grid>     

                </Grid>
                <Typography textAlign='center' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                  Equipments Loan
                  </Typography>
                <Modal
                    open={modal_open}
                    onClose={closeModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                > 
                    <Box sx={style}>

                    <TextField
                        size='small'
                        fullWidth
                        type='number'
                        variant='standard'
                        label='Period (in months)'
                        name='months'
                        sx={{ m:2 }}
                        value={months}
                        onChange={(e) => setMonths(e.target.value)}
                    />
                      <Accordion 
                          sx={{ borderRadius:2, mb:2 }}
                      >
                          <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel2a-content"
                              id="panel3a-header"
                              display='flex'
                          >
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Private interest?</b></Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Grid container spacing={1}>
                              <Grid item xs={12} md={12}>
                                  <FormControl>
                                    <FormLabel id="demo-row-radio-buttons-group-label">Type</FormLabel>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name='int_type'
                                        value={int_type}
                                        onChange={(e) => setInt_type(e.target.value)}
                                    >
                                        <FormControlLabel value="flat_rate" control={<Radio />} label="Fixed Amount" />
                                        <FormControlLabel value="percentage_rate" control={<Radio />} label="Percentage Rate" />
                                        <FormControlLabel value="" control={<Radio />} label="Default" />
                                    </RadioGroup>
                                </FormControl>
                              </Grid>

                              <Grid item xs={12} md={12}>
                                    {
                                      int_type === 'flat_rate'?(
                                          <TextField
                                              size='small'
                                              fullWidth
                                              type='number'
                                              variant='standard'
                                              label='Type here'
                                              inputProps={{ step: 'any' }}
                                              name='private_interest'
                                              value={private_interest}
                                              onChange={(e) => setPrivate_interest(e.target.value)}
                                          />
                                      ): int_type === 'percentage_rate'?(
                                          <>
                                          <TextField
                                              size='small'
                                              fullWidth
                                              type='number'
                                              variant='standard'
                                              label='Type here (%)'
                                              inputProps={{ step: 'any' }}
                                              name='private_interest'
                                              value={private_interest}
                                              onChange={(e) => setPrivate_interest(e.target.value)}
                                          />
                                          
                                          </>
                                      ):null
                                  }
                              </Grid>
                            </Grid>
                              
                              

                          </AccordionDetails>
                      </Accordion>
                      <Button
                          variant='contained'
                          onClick={closeModal}
                          color='error'
                          size='small'
                          sx={{   m:1, 
                              borderRadius:4,
                              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                              minWidth: 0,
                              '&:hover': {
                              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                              backgroundColor:'#bc6c25',
                              color:'#000'
                              },
                          }}
                        >
                          Close
                        </Button>
                        <Button
                          variant='contained'
                          onClick={Subscribe}
                          size='small'
                          sx={{   m:1, 
                              borderRadius:4,
                              backgroundColor:'#eb5e28',
                              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                              minWidth: 0,
                              '&:hover': {
                              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                              backgroundColor:'#bc6c25',
                              color:'#000'
                              },
                          }}
                        >
                          Subscribe
                        </Button>
                    </Box>
                </Modal>

                <Modal
                    open={open}
                    onClose={closeModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                > 
                    <Box sx={style}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={12}>
                          <Typography sx={{ textAlign:'center' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Equipment loan repayment</b>
                          </Typography>
                        </Grid>
                          <Grid item xs={12} md={12}>
                            <Autocomplete
                                disablePortal
                                id="combo-box-demo"
                                options={props.savings_acc}
                                sx={{ width: 300, mt:3, marginBottom:1 }}
                                getOptionLabel={(option) => option.Account_Name}
                                isOptionEqualToValue={(option, value) => option.ID === value.ID}
                                onChange={(event, value) => {
                                  setSavings_id(value.ID)
                                  setnot_more(value.Current_Balance)
                                }}
                                renderInput={(params) => <TextField {...params} fullWidth size='small' label="Select Account" />}
                            />
                          </Grid>

                          <Grid item xs={12} md={12}>
                            <TextField
                              size='small'
                              value={cash_hold}
                              onChange={(e) => set_cash_hold(e.target.value)}
                              label="Amount to be paid"
                              max={not_more}
                              type='number'
                              inputProps={{ step: 'any' }}
                            />
                          </Grid>
                          <Grid item xs={12} md={12}>
                            <Button
                              variant='contained'
                              onClick={closeModal}
                              color='error'
                              size='small'
                              sx={{   m:1, 
                                  borderRadius:4,
                                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                  minWidth: 0,
                                  '&:hover': {
                                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                  backgroundColor:'#bc6c25',
                                  color:'#000'
                                  },
                              }}
                            >
                              Cancel
                            </Button>

                            <Button
                              variant='contained'
                              onClick={ConfirmPayment}
                              size='small'
                              sx={{   m:1, 
                                  borderRadius:4,
                                  backgroundColor:'#eb5e28',
                                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                  minWidth: 0,
                                  '&:hover': {
                                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                  backgroundColor:'#bc6c25',
                                  color:'#000'
                                  },
                              }}
                            >
                              Confirm Payment
                            </Button>
                          </Grid>
                      </Grid>    
                    </Box>
                </Modal>

                <Button
                    variant='contained'
                    onClick={closeErr}
                    color='error'
                    size='small'
                    SX={{ m:1, borderRadius:4 }}
                >
                    Close
                </Button>

            <Snackbar
                open={ope}
                autoHideDuration={3000}
                onClose={handleClo}
                message={message}
                action={actio}
            />
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={openn}
                onClick={handleCloses}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </Item>
    </LocalizationProvider>
       
  )

}

